import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import "./styles.scss";
import Select from "react-select";
import { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";


import { TimePicker } from "antd";
import dayjs from "dayjs";


//SELECÇÃO DE NOTIFICAÇÃO PRINCIPAL
export const tipoNotificacaoBase = [
  { value: "area", label: "Área" },
  { value: "bateria", label: "Bateria" },
  { value: "entrada", label: "Entrada" },
  { value: "ignicao", label: "Ignição" },
  { value: "rpm", label: "RPM" },
  { value: "rota", label: "Rota" },
  { value: "excesso_tempo_parado", label: "Excesso de Tempo Parado" },
  { value: "emergencia", label: "Parada de Emergência" },
  { value: "temperatura", label: "Temperatura Ambiente" },
  { value: "temperatura_unidade", label: "Temperatura da Unidade" },
  { value: "temperatura_motor", label: "Temperatura do Motor" },
  { value: "velocidade", label: "Velocidade" },
];

function NotificaçãoCad({ modo = "create" }) {
  const { id } = useParams();
  const navigate = useNavigate();
  let vetorTemSelect = ["area", "entrada", "rota"];
  let vetorTemCriterio = ["area", "velocidade", "rpm", "bateria", "entrada", "ignicao", "temperatura", "temperatura_unidade", "temperatura_motor", "rota"];
  let vetorTemInput = ["bateria", "temperatura", "temperatura_unidade", "temperatura_motor", "velocidade", "rpm"];
  let vetorTemSelect1 = ["area1", "entrada1", "rota1"];
  let vetorTemCriterio1 = ["area1", "bateria1", "entrada1", "ignicao1", "temperatura1", "temperatura_unidade1", "temperatura_motor1", "rota1", "rpm1", "velocidade1"];
  let vetorTemInput1 = ["bateria1", "temperatura1", "temperatura_unidade1", "temperatura_motor1", "velocidade1", "rpm1"];


  const [notificacoesPredefinidas, setNotificacoesPredefinidas] = useState([]);
  const [notificacoesSelecionadas, setNotificacoesSelecionadas] = useState([]);
  const [notificacoesPredefinidasCopy, setNotificacoesPredefinidasCopy] = useState([]);
  const [notificacoesSelecionadasCopy, setNotificacoesSelecionadasCopy] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [referencias, setReferencias] = useState([]);
  const [habilitarNotificacao, setHabilitarNotificacao] = useState("");
  const [values, setValues] = useState({});
  const [search, setSearch] = useState("");
  const [inicializado, setInicializado] = useState(false);
  const [tipoReferenciaP, setTipoReferenciaP] = useState("");
  const [tipoReferenciaS, setTipoReferenciaS] = useState("");
  const [loadingVeiculos, setLoadingVeiculos] = useState(true);



  const setSelectValue = (name, value) => {
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };




  // ==============================
  // EDIÇÃO - BUSCAR NOTIFICAÇÃO
  // ==============================
  // ============================================================
  // EDIÇÃO - BUSCAR NOTIFICAÇÃO PELO ID
  // ============================================================
  useEffect(() => {

    // ----------------------------------------------------------
    // 1. VERIFICAR SE O USEEFFECT FOI EXECUTADO
    // ----------------------------------------------------------
    console.log("1️⃣ USE EFFECT EDITAR:", {
      modo,
      id,
    });


    // ----------------------------------------------------------
    // 2. VERIFICAR SE ESTAMOS REALMENTE NO MODO DE EDIÇÃO
    // ----------------------------------------------------------
    //
    // Se não for "edit" OU não existir um ID,
    // não fazemos a requisição.
    //
    if (modo !== "edit" || !id) {

      console.log(
        "2️⃣ NÃO ENTROU: modo ou id inválido"
      );

      return;
    }


    // ==========================================================
    // FUNÇÃO PARA BUSCAR A NOTIFICAÇÃO
    // ==========================================================
    async function fetchById() {

      console.log(
        "3️⃣ VAI BUSCAR NOTIFICAÇÃO:",
        id
      );


      try {

        // ------------------------------------------------------
        // 3.1 - ANTES DE FAZER O GET
        // ------------------------------------------------------
        console.log(
          "3.1️⃣ ANTES DO API.GET"
        );


        // ------------------------------------------------------
        // 3.2 - FAZER REQUISIÇÃO PARA O BACKEND
        // ------------------------------------------------------
        //
        // Exemplo:
        //
        // GET /notificacao/737
        //
        // Os headers são os mesmos que você já utiliza
        // nas outras requisições.
        //
        const response = await api.get(
          `/notificacao/${id}`,
          {
            headers: {
              typo: localStorage.getItem("id"),
              inova: localStorage.getItem("inova"),
            },
          }
        );


        // ------------------------------------------------------
        // 3.3 - SE CHEGOU AQUI, O GET FUNCIONOU
        // ------------------------------------------------------
        console.log(
          "3.2️⃣ API.GET TERMINOU"
        );


        // ------------------------------------------------------
        // 3.4 - STATUS HTTP
        // ------------------------------------------------------
        console.log(
          "3.3️⃣ STATUS:",
          response.status
        );


        // ------------------------------------------------------
        // 3.5 - DADOS RECEBIDOS DO BACKEND
        // ------------------------------------------------------
        console.log(
          "3.4️⃣ DATA:",
          response.data
        );


        // ======================================================
        // DADOS RECEBIDOS
        // ======================================================

        const data = response.data;


        // ------------------------------------------------------
        // 4 - TRATAMENTO DO TIPO DE NOTIFICAÇÃO PRINCIPAL
        // ------------------------------------------------------
        //
        // O backend retorna:
        //
        // area
        // rota
        // bateria
        //
        // Porém, no frontend o principal utiliza:
        //
        // area1
        // rota1
        // bateria1
        //
        // Por isso adicionamos o "1".
        //
        const tipoPrincipal = data.tipoNotificacao1
          ? data.tipoNotificacao1.endsWith("1")
            ? data.tipoNotificacao1
            : `${data.tipoNotificacao1}1`
          : "";


        console.log(
          "5️⃣ TIPO PRINCIPAL:",
          tipoPrincipal
        );


        // ------------------------------------------------------
        // 6 - SALVAR OS TIPOS NOS STATES
        // ------------------------------------------------------

        setTipoNotificacaoP(
          tipoPrincipal
        );

        setTipoNotificacaoS(
          data.tipoNotificacao ?? ""
        );


        // ======================================================
        // 7 - TRATAR PLACAS
        // ======================================================
        //
        // O backend pode retornar placa como:
        //
        // Array:
        // ["ABC1234", "DEF5678"]
        //
        // ou String:
        // "'ABC1234','DEF5678'"
        //
        // Aqui transformamos tudo em array.
        //

        let placas = [];


        if (Array.isArray(data.placa)) {

          // Caso já seja um array
          placas = data.placa;

        } else if (typeof data.placa === "string") {

          // Caso seja uma string
          placas = data.placa
            .replace(/'/g, "")
            .split(",")
            .map((placa) => placa.trim())
            .filter(Boolean);
        }


        console.log(
          "6️⃣ PLACAS:",
          placas
        );


        // ------------------------------------------------------
        // Salvar placas selecionadas
        // ------------------------------------------------------

        setNotificacoesSelecionadas(
          placas
        );


        // ======================================================
        // 8 - PREENCHER CAMPOS PRINCIPAIS
        // ======================================================

        setValues({
          // Grupo
          grupo:
            data.grupo ?? null,

          // Forma de notificação
          notificar_por:
            data.notificar_por ?? null,


          status_alerta:
            data.status === "Ligado"
              ? "S"
              : data.status === "Desligado"
                ? "N"
                : data.status
                  ? String(data.status).toUpperCase()
                  : null,

          // Mensagem
          mensagem:
            data.mensagem ?? "",
        });


        // ======================================================
        // 9 - HABILITAR NOTIFICAÇÃO
        // ======================================================

        setHabilitarNotificacao(
          data.habilitarNotificacao === "s" ||
          data.habilitarNotificacao === true
        );


        // ======================================================
        // 10 - PREENCHER NOTIFICAÇÃO PRINCIPAL
        // ======================================================

        if (data.tipoNotificacao1) {

          const prefixo =
            tipoPrincipal;


          // ----------------------------------------------------
          // 10.1 - PONTO DE REFERÊNCIA
          // ----------------------------------------------------

          if (
            data.ponto_referencia_id_principal
          ) {

            setValues((v) => ({
              ...v,

              // Se for Área
              ...(prefixo.includes("area") && {
                ponto_referencia_id_area_1:
                  data.ponto_referencia_id_principal,
              }),

              // Se for Rota
              ...(prefixo.includes("rota") && {
                ponto_referencia_id_rota_1:
                  data.ponto_referencia_id_principal,
              }),
            }));
          }


          // ----------------------------------------------------
          // 10.2 - CRITÉRIO
          // ----------------------------------------------------

          if (
            data.criterio_principal
          ) {

            // Excesso de tempo parado possui
            // tratamento especial.
            if (
              tipoPrincipal ===
              "excesso_tempo_parado1"
            ) {

              setTipoReferenciaP(
                data.criterio_principal
              );

            } else {

              setValues((v) => ({
                ...v,

                [`${tipoPrincipal}_criterio`]:
                  data.criterio_principal,
              }));
            }
          }


          // ----------------------------------------------------
          // 10.3 - VALOR DO CRITÉRIO
          // ----------------------------------------------------

          if (
            data.criterio_valor_principal !== null &&
            data.criterio_valor_principal !== undefined
          ) {

            setValues((v) => ({
              ...v,

              // Valor genérico do critério
              [`criterio_valor_${prefixo}`]:
                data.criterio_valor_principal,

              // Excesso de tempo parado
              ...(prefixo ===
                "excesso_tempo_parado1" && {
                tempo_maximo_permitido_1:
                  data.criterio_valor_principal,
              }),
            }));
          }
        }


        // ======================================================
        // 11 - PREENCHER NOTIFICAÇÃO SECUNDÁRIA
        // ======================================================

        if (data.tipoNotificacao) {

          const prefixo =
            data.tipoNotificacao;


          // ----------------------------------------------------
          // 11.1 - PONTO DE REFERÊNCIA
          // ----------------------------------------------------

          if (
            data.ponto_referencia_id_sec
          ) {

            setValues((v) => ({
              ...v,

              // Área
              ...(prefixo === "area" && {
                ponto_referencia_id_area:
                  data.ponto_referencia_id_sec,
              }),

              // Rota
              ...(prefixo === "rota" && {
                ponto_referencia_id_rota:
                  data.ponto_referencia_id_sec,
              }),
            }));
          }


          // ----------------------------------------------------
          // 11.2 - CRITÉRIO
          // ----------------------------------------------------

          if (
            data.criterio_sec
          ) {

            // Excesso de tempo parado
            // possui tratamento especial.
            if (
              prefixo ===
              "excesso_tempo_parado"
            ) {

              setTipoReferenciaS(
                data.criterio_sec
              );

            } else {

              setValues((v) => ({
                ...v,

                [`${prefixo}_criterio`]:
                  data.criterio_sec,
              }));
            }
          }


          // ----------------------------------------------------
          // 11.3 - VALOR DO CRITÉRIO
          // ----------------------------------------------------

          if (
            data.criterio_valor_sec !== null &&
            data.criterio_valor_sec !== undefined
          ) {

            setValues((v) => ({
              ...v,

              // Valor genérico
              [`criterio_valor_${prefixo}`]:
                data.criterio_valor_sec,

              // Excesso de tempo parado
              ...(prefixo ===
                "excesso_tempo_parado" && {
                tempo_maximo_permitido:
                  data.criterio_valor_sec,
              }),
            }));
          }
        }


        // ======================================================
        // 12 - FINALIZOU O PREENCHIMENTO
        // ======================================================

        console.log(
          "7️⃣ FINALIZOU PREENCHIMENTO"
        );

        console.log(
          "📦 VALUES FINAL:",
          {
            tipoNotificacaoP: tipoPrincipal,
            tipoNotificacaoS:
              data.tipoNotificacao ?? "",
            placas,
            grupo: data.grupo,
            notificar_por:
              data.notificar_por,
            status:
              data.status,
            mensagem:
              data.mensagem,
            habilitarNotificacao:
              data.habilitarNotificacao,
          }
        );


      } catch (error) {

        // ======================================================
        // ERRO NA REQUISIÇÃO
        // ======================================================

        console.log(
          "❌❌❌ ERRO NO GET ❌❌❌"
        );


        // Erro completo
        console.log(
          "❌ ERROR:",
          error
        );


        // Mensagem do erro
        console.log(
          "❌ MESSAGE:",
          error?.message
        );


        // Resposta do servidor
        console.log(
          "❌ RESPONSE:",
          error?.response
        );


        // Status HTTP
        console.log(
          "❌ STATUS:",
          error?.response?.status
        );


        // Dados enviados pelo backend
        console.log(
          "❌ DATA:",
          error?.response?.data
        );


        // Configuração do Axios
        console.log(
          "❌ CONFIG:",
          error?.config
        );


        // URL utilizada
        console.log(
          "❌ URL:",
          error?.config?.url
        );


        // Método HTTP
        console.log(
          "❌ METHOD:",
          error?.config?.method
        );


        // Headers utilizados
        console.log(
          "❌ HEADERS:",
          error?.config?.headers
        );
      }
    }


    // ==========================================================
    // EXECUTAR BUSCA
    // ==========================================================

    fetchById();


    // ============================================================
    // DEPENDÊNCIAS DO USEEFFECT
    // ============================================================

  }, [modo, id]);















  //PRINCIPAL(CRITÉRIOS POR TIPO)
  const criteriosPorTipo = {
    area1: [
      { value: "entrar", label: "Entrar" },
      { value: "sair", label: "Sair" },
      { value: "ambos", label: "Ambos" },
    ],
    rpm1: [
      { value: "maior", label: "Maior que" },
      { value: "menor", label: "Menor que" },
    ],

    velocidade1: [
      { value: "maior", label: "Maior que" },
      { value: "menor", label: "Menor que" },
    ],
    rota1: [
      { value: "entrar", label: "Entrar" },
      { value: "sair", label: "Sair" },
      { value: "ambos", label: "Entrar/Sair" },
      { value: "dentro", label: "Dentro" },
      { value: "fora", label: "Fora" },
    ],
    bateria1: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
      { value: "falha", label: "Falha de bateria" },
    ],
    entrada1: [
      { value: "ligado", label: "Ligado" },
      { value: "desligado", label: "Desligado" },
      { value: "ambos", label: "Ambos" },
    ],
    ignicao1: [
      { value: "ligado", label: "Ligado" },
      { value: "desligado", label: "Desligado" },
      { value: "ambos", label: "Ambos" },
    ],
    temperatura1: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],
    temperatura_unidade1: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],
    temperatura_motor1: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],

    emergencia1: [
      { value: "acionado", label: "Acionado" },
      { value: "nao acionado", label: "Não Acionado" }
    ]



  };




  //CRITERIOS OPÇÕES (SEGUNDARIO)
  const criteriosPorTipoS = {
    area: [
      { value: "entrar", label: "Entrar" },
      { value: "sair", label: "Sair" },
      { value: "ambos", label: "Ambos" },
    ],
    rpm: [
      { value: "maior", label: "Maior que" },
      { value: "menor", label: "Menor que" },
    ],

    velocidade: [
      { value: "maior", label: "Maior que" },
      { value: "menor", label: "Menor que" },
    ],

    emergencia: [
      { value: "acionado", label: "Acionado" },
      { value: "nao_acionado", label: "Não Acionado" },
    ],

    bateria: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
      { value: "falha", label: "Falha de bateria" },
    ],
    rota: [
      { value: "entrar", label: "Entrar" },
      { value: "sair", label: "Sair" },
      { value: "ambos", label: "Entrar/Sair" },
      { value: "dentro", label: "Dentro" },
      { value: "fora", label: "Fora" },
    ],
    entrada: [
      { value: "ligado", label: "Ligado" },
      { value: "desligado", label: "Desligado" },
      { value: "ambos", label: "Ambos" },
    ],
    ignicao: [
      { value: "ligado", label: "Ligado" },
      { value: "desligado", label: "Desligado" },
      { value: "ambos", label: "Ambos" },
    ],
    temperatura: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],
    temperatura_unidade: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],
    temperatura_motor: [
      { value: "maior", label: "Maior" },
      { value: "menor", label: "Menor" },
    ],
  };








  //PRINCIPAL(OPÇÕES DE ENTRADA)
  const opcoesEntrada = [
    { value: "entrada1", label: "Entrada 01" },
    { value: "entrada2", label: "Entrada 02" },
    { value: "entrada3", label: "Entrada 03" },
  ];
  //SEGUNDARIA(OPÇÕES DE ENTRADA)
  const opcoesEntradaS = [
    { value: "entrada1", label: "Entrada 01" },
    { value: "entrada2", label: "Entrada 02" },
    { value: "entrada3", label: "Entrada 03" },
  ];

  // ======================================================
  //  FILTRO E RANQUEAMENTO DE VEÍCULOS (SEARCH INTELIGENTE)
  // ======================================================

  // Normaliza textos para comparação consistente:
  // - converte para string
  // - remove diferenciação de maiúsculas/minúsculas
  // - remove acentos e variações de caracteres
  // Exemplo: "ÇãO-123" → "cao-123"
  const normalizar = (txt = "") =>
    txt
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  // Verifica se o termo digitado é composto apenas por números
  // Usado para diferenciar buscas por código/id de buscas por texto
  const isNumero = (txt) => /^\d+$/.test(txt);

  // Extrai todas as sequências numéricas de um texto
  // Exemplo: "BA - 1965 | 4026" → ["1965", "4026"]
  // Fundamental para permitir busca numérica dentro da descrição
  const extrairNumeros = (txt = "") =>
    txt.match(/\d+/g) || [];


  // ------------------------------------------------------
  //  CÁLCULO DE RELEVÂNCIA (SCORE) DO VEÍCULO
  // ------------------------------------------------------
  // Retorna um número que representa o quão relevante
  // o veículo é em relação ao termo digitado.
  // Quanto maior o score, mais acima ele aparece na lista.
  const calcularScore = (veiculo, termo) => {
    const t = normalizar(termo);
    if (!t) return 0;

    const placa = normalizar(veiculo.placa);
    const nome = normalizar(veiculo.nome);

    const termoEhNumero = isNumero(t);
    const numerosNome = extrairNumeros(nome); //  números presentes na descrição

    //  PRIORIDADE MÁXIMA
    // Match numérico exato dentro da descrição
    // Ex: busca "1527" → " | 1527"
    if (termoEhNumero && numerosNome.includes(t)) return 100;

    // Match exato da placa inteira
    if (placa === t) return 95;

    //  COMEÇA COM
    // Placa iniciando com o termo digitado
    if (placa.startsWith(t)) return 90;

    // Número da descrição começando com o termo
    if (termoEhNumero && numerosNome.some(n => n.startsWith(t))) return 85;

    //  CONTÉM
    // Termo aparece em qualquer parte da placa
    if (placa.includes(t)) return 70;

    // Número aparece em qualquer parte da descrição
    if (termoEhNumero && numerosNome.some(n => n.includes(t))) return 65;

    //  BUSCA TEXTUAL (quando o termo não é numérico)
    if (!termoEhNumero) {
      if (nome.startsWith(t)) return 50;
      if (nome.includes(t)) return 30;
    }

    // Nenhuma correspondência relevante encontrada
    return 0;
  };


  // ------------------------------------------------------
  //  REMOÇÃO DE VEÍCULOS DUPLICADOS (PLACA ÚNICA)
  // ------------------------------------------------------
  // Garante que cada placa apareça apenas uma vez,
  // mesmo que venha duplicada da API ou banco
  const veiculosUnicos = Array.from(
    new Map(
      notificacoesPredefinidas.map(v => [v.placa, v])
    ).values()
  );


  // ------------------------------------------------------
  //  LISTA FINAL EXIBIDA NO SELECT
  // ------------------------------------------------------
  // - Sem busca: retorna todos os veículos únicos
  // - Com busca: calcula score, filtra e ordena por relevância
  const filterPlaca = !search
    ? veiculosUnicos
    : veiculosUnicos
      .map(v => ({
        ...v,
        _score: calcularScore(v, search),
      }))
      .filter(v => v._score > 0)
      .sort((a, b) => {
        // Primeiro ordena pela relevância
        if (b._score !== a._score) return b._score - a._score;

        // Em caso de empate, ordena alfabeticamente pela placa
        return a.placa.localeCompare(b.placa);
      });












  //ATUALIZAÇÃO DINAMICA DO FORMULARIO
  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  // SELECIONADORES DE OPÇÕES


  //NOME DO GRUPO PARA O SWAL
  const getNomeGrupo = () => {
    return values.grupo?.label ?? "-";
  };



  // OPÇÕES PARA TIPO DE REFERENCIA(EXCESSO TEMPO PARADO AREA E ROTA)
  const tipoReferenciaOptions = [
    { value: "area", label: "Área" },
    { value: "rota", label: "Rota" },
  ];


  // OPÇÕES NOTIFICAR 
  const notificarOptions = [
    { value: "", label: "Selecione" },
    { value: "placa", label: "Placa" },
    { value: "descricao", label: "Descrição" },
  ];


  //OPCAO STATUS ALERTA
  const statusOptions = [
    { value: "", label: "Selecione" },
    { value: "S", label: "Ligado" },
    { value: "N", label: "Desligado" },

  ];

  // NOTIFICAÇÃO
  const [tipoNotificacaoP, setTipoNotificacaoP] = useState("");
  const [tipoNotificacaoS, setTipoNotificacaoS] = useState("");

  // TIPO DE NOTIFICAÇÃO (10 opções)
  // const tipoNotificacaoBase = [
  //   { value: "area", label: "Área" },
  //   { value: "bateria", label: "Bateria" },
  //   { value: "entrada", label: "Entrada" },
  //   { value: "ignicao", label: "Ignição" },
  //   { value: "rpm", label: "RPM" },
  //   { value: "rota", label: "Rota" },
  //   { value: "excesso_tempo_parado", label: "Excesso de Tempo Parado" },
  //   { value: "emergencia", label: "Parada de Emergência" },
  //   { value: "temperatura", label: "Temperatura Ambiente" },
  //   { value: "temperatura_unidade", label: "Temperatura da Unidade" },
  //   { value: "temperatura_motor", label: "Temperatura do Motor" },
  //   { value: "velocidade", label: "Velocidade" },
  // ];

  // GERAR OPÇÕES COM SUFIXO (1 OU VAZIO)
  const gerarTipoNotificacaoOptions = (sufixo = "") =>
    tipoNotificacaoBase.map((opt) => ({
      value: `${opt.value}${sufixo}`,
      label: opt.label,
    }));

  // TIPO DE NOTIFICAÇÃO 1 
  const tipoNotificacao1_Options = gerarTipoNotificacaoOptions("1");
  // TIPO DE NOTIFICAÇÃO 2
  const tipoNotificacaoS_Options = gerarTipoNotificacaoOptions("");

  // PONTOS DE REFERÊNCIA
  const referenciaOptions = referencias.map((r) => ({
    value: r.id,
    label: r.descricao,
  }));

  // TEMPERATURA PRINCIPAL(OPCÕES DE TEMPERATURA)
  const temperaturaConfig = {
    temperatura1: {
      label: "Temperatura ambiente",
      min: -20,
      max: 60,
      unidade: "°C",
      default: 0,
    },
    temperatura_unidade1: {
      label: "Temperatura da unidade",
      min: 0,
      max: 80,
      unidade: "°C",
      default: 0,
    },
    temperatura_motor1: {
      label: "Temperatura do motor",
      min: 60,
      max: 130,
      unidade: "°C",
      default: 0,
    },
  };


  // TEMPERATURA SEGUNDARIA(OPÇÕES DE TEMPERATURA)
  const temperaturaSConfig = {
    temperatura: {
      label: "Temperatura ambiente",
      min: -20,
      max: 60,
      unidade: "°C",
      default: 25,
    },
    temperatura_unidade: {
      label: "Temperatura da unidade",
      min: 0,
      max: 80,
      unidade: "°C",
      default: 20,
    },
    temperatura_motor: {
      label: "Temperatura do motor",
      min: 60,
      max: 130,
      unidade: "°C",
      default: 90,
    },
  };






















  const handleSelecionadase = (event) => {
    const selecionados = Array.from(
      event.target.selectedOptions,
      opt => opt.value
    );

    setNotificacoesSelecionadas((prev) => {
      const novos = selecionados.filter(v => !prev.includes(v));
      return [...prev, ...novos];
    });

    setNotificacoesPredefinidas((prev) =>
      prev.filter(v => !selecionados.includes(v))
    );
  };




  const incluiSelect = (valor) => (vetorTemSelect.indexOf(valor) !== -1 ? true : false);

  const incluiCriterio = (valor) => (vetorTemCriterio.indexOf(valor) !== -1 ? true : false);

  const incluiInput = (valor) => (vetorTemInput.indexOf(valor) !== -1 ? true : false);

  const incluiSelect1 = (valor) => (vetorTemSelect1.indexOf(valor) !== -1 ? true : false);

  const incluiCriterio1 = (valor) => (vetorTemCriterio1.indexOf(valor) !== -1 ? true : false);

  const incluiInput1 = (valor) => (vetorTemInput1.indexOf(valor) !== -1 ? true : false);

  const [carregandoVeiculos, setCarregandoVeiculos] = useState(false);
  const [erroVeiculos, setErroVeiculos] = useState(false);

  //INICIALIZAÇÃO

  useEffect(() => {
    async function fetchEquipamentos() {
      setCarregandoVeiculos(true);
      setErroVeiculos(false);

      try {
        const { data } = await api.get("/equipamentos", {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        });

        const veiculos = data.map(v => ({
          placa: v.placa,
          nome: v.nome,
        }));

        setNotificacoesPredefinidas(veiculos);

        if (modo !== "edit") {
          setNotificacoesSelecionadas([]);
        }

        console.log(`Veículos carregados: ${veiculos.length}`);
      } catch (error) {
        console.error("Erro ao carregar veículos:", error);
        setErroVeiculos(true);
      } finally {
        setCarregandoVeiculos(false);
        setInicializado(true);
      }
    }

    if (!inicializado) {
      fetchEquipamentos();
    }
  }, [inicializado]);



  useEffect(() => {
    async function fetchGrupos() {
      const { data } = await api.get("/grupos1", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });
      setGrupos(data);
    }
    fetchGrupos();
  }, []);


  useEffect(() => {
    async function fetchReferencias() {
      const { data } = await api.get("/referenciass", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });
      setReferencias(data);
    }
    fetchReferencias();
  }, []);


  const backupSelecionadosRef = useRef([]);




  //SELECIONAR TODOS OS VEICULOS 
  const handleAll = (checked) => {
    if (checked) {
      // salva estado original apenas uma vez
      if (notificacoesSelecionadas.length === 0) {
        setNotificacoesPredefinidasCopy([...notificacoesPredefinidas]);
      }

      // seleciona todas as placas
      const todasPlacas = filterPlaca.map(v => v.placa);
      setNotificacoesSelecionadas(todasPlacas);
    } else {
      // desmarca tudo
      setNotificacoesSelecionadas([]);
    }
  };



  // Buscar pontos de referência
  const TIPOS_AREA = ["circulo", "polygon", "rectangule"];
  const [pontosRef, setPontosRef] = useState([]);

  useEffect(() => {
    async function fetchPontos() {
      const { data } = await api.get("/pontosreferencias", {
        headers: {
          typo: localStorage.getItem("id"),
        },
      });
      setPontosRef(data);
    }

    fetchPontos();
  }, []);

  //Criar OPTIONS SEPARADAS (AREA E ROTA)
  const areaOptions = pontosRef
    .filter(p => TIPOS_AREA.includes(p.tipo))
    .map(p => ({
      value: p.id,
      label: p.descricao,
    }));

  const rotaOptions = pontosRef
    .filter(p => p.tipo === "rota")
    .map(p => ({
      value: p.id,
      label: p.descricao,
    }));


  //ADICIONAR NOTIFICAÇÃO - CONFIRMAÇÃO
  const confirmouRef = useRef(false);

  const handleSelecionada = async (event) => {
    const placa = event.target.value;
    if (!placa) return;

    if (!confirmouRef.current) {
      const result = await Swal.fire({
        title: "Deseja Adicionar Veículos?",
        icon: "question",

        background: "#0f172a",
        color: "#ffffff",

        html: `
      <div style="margin-top:8px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          line-height:1.6;
          margin-bottom:18px;
          text-align:center;
        ">
          Após essa confirmação, você poderá adicionar vários veículos.
        </div>

        <div style="
          border:1px solid rgba(56,189,248,0.18);
          border-radius:12px;
          padding:14px;
          background:rgba(255,255,255,0.03);
          text-align:left;
        ">
          <p style="margin:6px 0;color:#fff">
            <b style="color:#38bdf8">Ação:</b> Liberar cadastro múltiplo
          </p>

          <p style="margin:6px 0;color:#fff">
            <b style="color:#38bdf8">Status:</b> Aguardando confirmação
          </p>
        </div>

      </div>
    `,

        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",

        confirmButtonColor: "#2563eb",
        cancelButtonColor: "#334155",

        reverseButtons: true,

        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "99999";
        }
      });

      if (!result.isConfirmed) {
        event.target.value = "";
        return;
      }

      confirmouRef.current = true;
    }

    setNotificacoesSelecionadas((prev) =>
      prev.includes(placa) ? prev : [...prev, placa]
    );

    //  limpa seleção SEM quebrar evento
    event.target.value = "";
  };








  //CONFIRMAÇÃO PARA REMOVER VEICULOS 
  const confirmouRemocaoRef = useRef(false);

  const handlePredefinidas = async (event) => {
    const selecionados = Array.from(
      event.target.selectedOptions,
      o => o.value
    );

    if (selecionados.length === 0) return;

    if (!confirmouRemocaoRef.current) {
      const result = await Swal.fire({
        title: "Deseja remover os veículos?",
        icon: "warning",

        background: "#0f172a",
        color: "#ffffff",

        html: `
      <div style="margin-top:8px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          line-height:1.6;
          margin-bottom:18px;
          text-align:center;
        ">
          Depois que a remoção for confirmada, esta mensagem não será exibida novamente.
        </div>

        <div style="
          border:1px solid rgba(245,158,11,0.18);
          border-radius:12px;
          padding:14px;
          background:rgba(255,255,255,0.03);
          text-align:left;
        ">
          <p style="margin:6px 0;color:#fff">
            <b style="color:#f59e0b">Ação:</b> Remover veículos selecionados
          </p>

          <p style="margin:6px 0;color:#fff">
            <b style="color:#f59e0b">Aviso:</b> Confirmação única
          </p>
        </div>

      </div>
    `,

        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",

        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#334155",

        reverseButtons: true,

        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "99999";
        }
      });
      if (!result.isConfirmed) return;
      confirmouRemocaoRef.current = true;
    }

    setNotificacoesSelecionadas(prev =>
      prev.filter(p => !selecionados.includes(p))
    );
  };





  // FORMATAÇÃO DE VALORES PARA O RESUMO
  function formatarValor(valor) {
    if (valor && typeof valor === "object") {
      return valor.label ?? valor.value ?? "-";
    }
    return valor;
  }




  const getLabelFromOptions = (options, value) => {
    const opt = options.find(o => o.value === value);
    return opt ? opt.label : value;
  };

  const CAMPOS_JA_RENDERIZADOS = [
    "grupo",
    "notificar_por",
    "status_alerta",

  ];

  const CAMPOS_IGNORADOS = [
    "cliente",
    "cliente_id",
    "criado_por",
  ];


  const gerarResumoApartirDoJSON = (camposIgnorados = []) => {
    return Object.entries(values)
      .filter(([key, value]) => {
        if (!value) return false;
        if (camposIgnorados.includes(key)) return false;
        return true;
      })
      .map(([key, value]) => {
        const label = key
          .replaceAll("_", " ")
          .replace(/\b\w/g, l => l.toUpperCase());

        const valorFormatado = formatarValor(value);

        return `<p><b>${label}:</b> ${valorFormatado}</p>`;
      })
      .join("");
  };









  //VALIDAÇÃO DE CAMPOS
  const validarCampos = () => {
    const temPlaca =
      notificacoesSelecionadas && notificacoesSelecionadas.length > 0;

    const temGrupo = !!values.grupo;

    // precisa ter pelo menos UM dos dois
    if (!temPlaca && !temGrupo) {
      return "Selecione pelo menos um veículo ou um grupo.";
    }

    if (!values.notificar_por) {
      return "Selecione como deseja ser notificado.";
    }

    if (!values.status_alerta) {
      return "Selecione o status do alerta.";
    }

    if (!tipoNotificacaoP) {
      return "Selecione a notificação principal.";
    }

    return null;
  };


  const gerarResumoNotificacaoAdicional = () => {
    if (!tipoNotificacaoS) {
      return `<p><i>Sem notificação adicional (opcional)</i></p>`;
    }

    const prefixo = tipoNotificacaoS; // ex: bateria, area, ignicao
    const linhas = [];

    // Tipo
    const tipoLabel =
      tipoNotificacaoS_Options.find(o => o.value === tipoNotificacaoS)?.label
      ?? primeiraMaiuscula(prefixo);

    linhas.push(`<p><b>Tipo:</b> ${tipoLabel}</p>`);

    // Valor (se existir)
    const valorKey = `criterio_valor_${prefixo}`;
    if (values[valorKey]) {
      linhas.push(`<p><b>Valor ${tipoLabel}:</b> ${formatarValor(values[valorKey])}</p>`);
    }

    // Critério
    if (prefixo === "excesso_tempo_parado") {
      linhas.push(`
          <p><b>Critério:</b> ${tipoReferenciaS === "area" ? "Área" :
          tipoReferenciaS === "rota" ? "Rota" :
            "<i>Não foi selecionado nenhum critério</i>"
        }</p>
          <p><b>Tempo máximo permitido:</b> ${values.tempo_maximo_permitido ?? "-"}</p>
        `);
    } else {
      const criterioKey = `${prefixo}_criterio`;
      linhas.push(`
          <p><b>Critério:</b> ${values[criterioKey]
          ? primeiraMaiuscula(formatarValor(values[criterioKey]))
          : "<i>Não foi selecionado nenhum critério</i>"
        }</p>
        `);
    }

    // Ponto de referência (Área / Rota)
    Object.entries(values).forEach(([key, value]) => {
      if (value && (key === "ponto_referencia_id_area" || key === "ponto_referencia_id_rota")) {
        linhas.push(`<p><b>Ponto de referência:</b> ${getNomePontoReferencia(value)}</p>`);
      }
    });

    return linhas.join("");
  };

  //FUNÇÃO PARA QUE TEXTOS A PRIMEIRA LETRA EM MAISCULA
  const primeiraMaiuscula = (texto = "") => {
    if (typeof texto !== "string") return texto;
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  };





  //MAPEANDO  GRUPOS
  const options = grupos.map(grupo => ({
    value: grupo.id,
    label: grupo.nome
  }));

  const getLabelByValue = (options, value) => {
    const opt = options.find(o => o.value === value);
    return opt ? opt.label : value;
  };



  const gerarResumoPorGrupo = (campos) => {
    return Object.entries(values)
      .filter(([key, value]) => {
        if (!value) return false;
        if (!campos.includes(key)) return false;
        return true;
      })
      .map(([key, value]) => {
        const label = key
          .replaceAll("_", " ")
          .replace(/\b\w/g, l => l.toUpperCase());

        let valorFormatado = value;

        //  STATUS ALERTA
        if (key === "status_alerta") {
          if (value === "S" || value === "s") {
            valorFormatado = "Ligado";
          } else if (value === "N" || value === "n") {
            valorFormatado = "Desligado";
          }
        }

        //  GRUPO → ID para NOME
        else if (key === "grupo") {
          valorFormatado = getLabelByValue(options, value);
        }

        // padrão
        else {
          valorFormatado = primeiraMaiuscula(formatarValor(value));
        }

        return `<p><b>${label}:</b> ${valorFormatado}</p>`;
      })
      .join("");
  };



  //MAPEAMANETO DE AREA E ROTA PARA PEGRA NOME
  const getNomePontoReferencia = (id) => {
    const opt =
      areaOptions.find(o => o.value === id) ||
      rotaOptions.find(o => o.value === id);

    return opt ? opt.label : id;
  };

  // RESUMO CADASTRO NOTIFICAÇÃO OBRIGATÓRIO
  const gerarResumoNotificacaoPrincipal = () => {
    if (!tipoNotificacaoP) {
      return `<p><i>Sem notificação principal</i></p>`;
    }

    const prefixo = tipoNotificacaoP;               // area1, bateria1
    const base = tipoNotificacaoP.replace("1", ""); // area, bateria

    const linhas = [];

    //  TIPO DA NOTIFICAÇÃO (Área, Bateria, etc)
    const tipoLabel =
      tipoNotificacao1_Options.find(o => o.value === tipoNotificacaoP)?.label
      ?? base.charAt(0).toUpperCase() + base.slice(1);

    linhas.push(`
        <p><b>Tipo:</b> ${tipoLabel}</p>
      `);

    //  VALOR (se existir)
    const valorKey = `criterio_valor_${prefixo}`;
    if (values[valorKey]) {
      linhas.push(`
          <p><b>Valor ${tipoLabel}:</b> ${formatarValor(values[valorKey])}</p>
        `);
    }

    // CRITÉRIO EXCESSO TEMPO MAXIMO
    if (base === "excesso_tempo_parado") {
      linhas.push(`
        <p><b>Critério:</b> ${tipoReferenciaP === 'area' ? "Área" : tipoReferenciaP === "rota" ? "Rota" : "<i>Não foi selecionado nenhum critério</i>"}</p>
        <p><b>Tempo máximo permitido:</b> ${values.tempo_maximo_permitido_1 ?? "-"}</p>
      `);
    } else {
      const criterioKey = `${prefixo}_criterio`;
      linhas.push(`
        <p><b>Critério:</b>
          ${values[criterioKey]
          ? primeiraMaiuscula(formatarValor(values[criterioKey]))
          : ""
        }
        </p>
      `);
    }


    // PONTO DE REFERÊNCIA (Área / Rota)
    Object.entries(values).forEach(([key, value]) => {
      if (
        value &&
        (key === "ponto_referencia_id_area_1" || key === "ponto_referencia_id_rota_1")
      ) {
        linhas.push(`
            <p><b>Ponto de referência:</b> ${getNomePontoReferencia(value)}</p>
          `);
      }
    });

    return linhas.join("");
  };


  // ENVIAR DADOS PARA API
  const handleSubmit = async () => {
    try {
      const erro = validarCampos();

      if (erro) {
        await Swal.fire({
          icon: "warning",
          title: "Campos obrigatórios",

          background: "#0f172a",
          color: "#ffffff",

          html: `
      <div style="margin-top:8px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          line-height:1.6;
          margin-bottom:18px;
          text-align:center;
        ">
          ${erro}
        </div>

        <div style="
          border:1px solid rgba(245,158,11,0.18);
          border-radius:12px;
          padding:14px;
          background:rgba(255,255,255,0.03);
          text-align:left;
        ">
          <p style="margin:6px 0;color:#fff">
            <b style="color:#f59e0b">Status:</b> Verifique os campos informados
          </p>

          <p style="margin:6px 0;color:#fff">
            <b style="color:#f59e0b">Ação:</b> Corrija os dados para continuar
          </p>
        </div>

      </div>
    `,

          confirmButtonText: "Entendi",
          confirmButtonColor: "#f59e0b"
        });

        return;
      }

      const result = await Swal.fire({
        title:
          modo === "edit"
            ? "Confirmar alterações?"
            : "Confirmar cadastro?",
        icon: "question",

        background: "#0f172a",
        color: "#ffffff",

        html: `
      <div style="margin-top:8px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          line-height:1.6;
          margin-bottom:18px;
          text-align:center;
        ">
          ${modo === "edit"
            ? "Revise os dados abaixo antes de salvar as alterações."
            : "Confira as informações antes de concluir o cadastro."
          }
        </div>

        <div style="
          border:1px solid rgba(56,189,248,0.18);
          border-radius:12px;
          padding:14px;
          background:rgba(255,255,255,0.03);
          text-align:left;
        ">

          <p style="margin:6px 0;color:#fff">
            <b style="color:#38bdf8">Tipo:</b>
            ${modo === "edit" ? "Atualização de registro" : "Novo cadastro"}
          </p>

          <p style="margin:6px 0;color:#fff">
            <b style="color:#38bdf8">Status:</b>
            Aguardando confirmação
          </p>

          <p style="margin:6px 0;color:#fff">
            <b style="color:#38bdf8">Notificação:</b>
            ${modo === "edit"
            ? "Os dados atuais serão substituídos."
            : "Um novo registro será criado no sistema."
          }
          </p>

        </div>

      </div>
    `,

        showCancelButton: true,
        confirmButtonText:
          modo === "edit"
            ? "Sim, salvar"
            : "Sim, cadastrar",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#2563eb",
        cancelButtonColor: "#334155",

        reverseButtons: true
      });

      if (!result.isConfirmed) return;

      const payload = buildPayload();

      /* =========================
        LOADER
      ========================= */
      Swal.fire({
        title:
          modo === "edit"
            ? "Salvando alterações..."
            : "Realizando cadastro...",

        background: "#0f172a",
        color: "#ffffff",

        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        html: `
      <div style="margin-top:10px">

        <div style="
          color:#cbd5e1;
          font-size:15px;
          margin-bottom:20px;
        ">
          ${modo === "edit"
            ? "Atualizando informações no sistema."
            : "Enviando dados para cadastro."
          }
        </div>

        <div style="
          display:flex;
          justify-content:center;
          align-items:center;
        ">
          <div style="
            width:58px;
            height:58px;
            border:4px solid rgba(255,255,255,0.08);
            border-top:4px solid #38bdf8;
            border-right:4px solid #0ea5e9;
            border-radius:50%;
            animation:spinSwal .8s linear infinite;
          "></div>
        </div>

        <div style="
          margin-top:18px;
          color:#64748b;
          font-size:13px;
        ">
          Isso pode levar alguns segundos...
        </div>

      </div>

      <style>
        @keyframes spinSwal{
          0%{transform:rotate(0deg)}
          100%{transform:rotate(360deg)}
        }
      </style>
    `
      });

      try {
        const tempoMinimo = new Promise((resolve) =>
          setTimeout(resolve, 2000)
        );

        const requisicao =
          modo === "edit"
            ? api.put(`/notificacao/${id}`, payload)
            : api.post("/notificacao", payload);

        /* espera API + tempo mínimo juntos */
        await Promise.all([requisicao, tempoMinimo]);

        /* NÃO FECHA */
        /* TROCA DIRETO PARA SUCESSO */
        await Swal.fire({
          icon: "success",

          title:
            modo === "edit"
              ? "Notificação atualizada!"
              : "Notificação cadastrada!",

          background: "#0f172a",
          color: "#ffffff",

          html: `
        <div style="margin-top:8px">

          <div style="
            color:#cbd5e1;
            font-size:15px;
            line-height:1.6;
            margin-bottom:18px;
            text-align:center;
          ">
            ${modo === "edit"
              ? "As alterações foram salvas com sucesso no sistema."
              : "O novo registro foi criado com sucesso no sistema."
            }
          </div>

          <div style="
            border:1px solid rgba(34,197,94,0.18);
            border-radius:12px;
            padding:14px;
            background:rgba(255,255,255,0.03);
            text-align:left;
          ">
            <p style="margin:6px 0;color:#fff">
              <b style="color:#22c55e">Status:</b>
              Finalizado com sucesso
            </p>
          </div>

        </div>
      `,

          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false
        });

      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Erro ao salvar",
          text: "Tente novamente.",

          background: "#0f172a",
          color: "#ffffff",
          confirmButtonColor: "#ef4444"
        });
      }

      navigate(-1);

    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível salvar a notificação.",
      });
    }
  };


  const buildPayload = () => {
    // ===============================
    // PRINCIPAL
    // ===============================
    let pontoReferenciaPrincipal = null;
    let criterioPrincipal = null;
    let criterioValorPrincipal = null;

    if (tipoNotificacaoP === "area1") {
      pontoReferenciaPrincipal = values.ponto_referencia_id_area_1 ?? null;
      criterioPrincipal = values.area1_criterio ?? null;
    }

    if (tipoNotificacaoP === "rota1") {
      pontoReferenciaPrincipal = values.ponto_referencia_id_rota_1 ?? null;
      criterioPrincipal = values.rota1_criterio ?? null;
    }

    if (tipoNotificacaoP === "excesso_tempo_parado1") {
      criterioPrincipal = tipoReferenciaP;

      pontoReferenciaPrincipal =
        tipoReferenciaP === "area"
          ? values.ponto_referencia_id_area_1
          : values.ponto_referencia_id_rota_1;

      criterioValorPrincipal = values.tempo_maximo_permitido_1 ?? null;
    }

    if (
      tipoNotificacaoP &&
      !["area1", "rota1", "excesso_tempo_parado1"].includes(tipoNotificacaoP)
    ) {
      criterioPrincipal = values[`${tipoNotificacaoP}_criterio`] ?? null;
      criterioValorPrincipal =
        values[`criterio_valor_${tipoNotificacaoP}`] ?? null;
    }

    // ===============================
    // SECUNDÁRIA (OPCIONAL)
    // ===============================
    let pontoReferenciaSec = null;
    let criterioSec = null;
    let criterioValorSec = null;

    if (tipoNotificacaoS === "area") {
      pontoReferenciaSec = values.ponto_referencia_id_area ?? null;
      criterioSec = values.area_criterio ?? null;
    }

    if (tipoNotificacaoS === "rota") {
      pontoReferenciaSec = values.ponto_referencia_id_rota ?? null;
      criterioSec = values.rota_criterio ?? null;
    }

    if (tipoNotificacaoS === "excesso_tempo_parado") {
      criterioSec = tipoReferenciaS;

      pontoReferenciaSec =
        tipoReferenciaS === "area"
          ? values.ponto_referencia_id_area
          : values.ponto_referencia_id_rota;

      criterioValorSec = values.tempo_maximo_permitido ?? null;
    }

    if (
      tipoNotificacaoS &&
      !["area", "rota", "excesso_tempo_parado"].includes(tipoNotificacaoS)
    ) {
      criterioSec = values[`${tipoNotificacaoS}_criterio`] ?? null;
      criterioValorSec =
        values[`criterio_valor_${tipoNotificacaoS}`] ?? null;
    }

    return {
      placa: notificacoesSelecionadas,
      cliente_id: Number(localStorage.getItem("id")),

      //  se for edição envia editado_por
      ...(modo === "edit"
        ? { editado_por: Number(localStorage.getItem("clientID")) }
        : { criado_por: Number(localStorage.getItem("clientID")) }
      ),

      grupo: values.grupo ?? null,
      notificar_por: values.notificar_por ?? null,
      status: values.status_alerta ?? null,
      mensagem: values.mensagem ?? null,
      habilitarNotificacao: habilitarNotificacao ? "s" : null,

      tipoNotificacao1: tipoNotificacaoP ?? null,
      tipoNotificacao: tipoNotificacaoS ?? null,

      ponto_referencia_id_principal: pontoReferenciaPrincipal,
      criterio_principal: criterioPrincipal,
      criterio_valor_principal: criterioValorPrincipal,

      ...(tipoNotificacaoS && {
        ponto_referencia_id_sec: pontoReferenciaSec,
        criterio_sec: criterioSec,
        criterio_valor_sec: criterioValorSec,
      }),
    };
  };


  return (
    <div className="principal">
      <div className="notificaoCad">

        <ToastContainer />

        <div className="card notificacao-card">

          <div className="modal-content notifi-modal">

            {/* =====================================================
                HEADER
            ====================================================== */}

            <div className="notificacao-header">

              <div className="notificacao-header-info">

                <div className="notificacao-header-icon">
                  <i className="bi bi-bell"></i>
                </div>

                <div>
                  <h4>
                    {modo === "edit"
                      ? "Editar notificação"
                      : "Nova notificação"}
                  </h4>

                  <span>
                    Configure os alertas para seus veículos
                  </span>
                </div>

              </div>

              <button
                type="button"
                className="notificacao-close"
                onClick={() => navigate("/maps/notificacao")}
              >
                <i className="bi bi-x-lg"></i>
              </button>

            </div>


            {/* =====================================================
                CORPO
            ====================================================== */}

            <div className="modal-body scroll-notificacao">


              {/* =====================================================
                  VEÍCULOS
              ====================================================== */}

              <div className="veiculos-section">


                {/* BUSCA */}

                <div className="veiculos-busca">

                  <i className="bi bi-search"></i>

                  <input
                    type="text"
                    className="veiculos-busca-input"
                    placeholder="Buscar veículos..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />

                </div>


                {/* SELECIONAR TODOS */}

                <div className="veiculos-select-all">

                  <label className="veiculos-checkbox">

                    <input
                      type="checkbox"
                      onChange={(e) => handleAll(e.target.checked)}
                    />

                    <span className="veiculos-checkmark"></span>

                    <span className="veiculos-checkbox-text">
                      Selecionar todos os veículos
                    </span>

                  </label>

                </div>


                {/* LISTAS DE VEÍCULOS */}

                <div className="selects">


                  {/* =================================================
                      VEÍCULOS DISPONÍVEIS
                  ================================================== */}

                  <div className="veiculos-lista">

                    <small className="veiculos-titulo">
                      Placa do veículo | descrição
                    </small>


                    <select
                      className="carregamento-veiculos"
                      size={12}
                      onChange={handleSelecionada}
                    >{carregandoVeiculos && (
                      <div className="loading-frota">
                        <div className="loading-frota-card">
                          <div className="loading-frota-icon">
                            <i className="fas fa-truck-moving" />
                          </div>

                          <div className="loading-frota-status">
                            <span className="loading-frota-dot" />
                            CARREGANDO DADOS
                          </div>

                          <h3>Preparando sua frota</h3>

                          <p>
                            Estamos sincronizando os veículos e organizando
                            as informações para você.
                          </p>

                          <div className="loading-frota-dots">
                            <span />
                            <span />
                            <span />
                          </div>

                          <span className="loading-frota-footer">
                            INOVA RASTREAMENTO
                          </span>
                        </div>
                      </div>
                    )}
                      {filterPlaca
                        .filter(
                          v => !notificacoesSelecionadas.includes(v.placa)
                        )
                        .map(v => (
                          <option
                            key={v.placa}
                            value={v.placa}
                          >
                            {v.placa} | {v.nome}
                          </option>
                        ))
                      }

                    </select>

                  </div>


                  {/* =================================================
                      VEÍCULOS SELECIONADOS
                  ================================================== */}

                  <div className="veiculos-lista">

                    <small className="veiculos-titulo">
                      Veículos selecionados
                    </small>

                    <select
                      className="carregamento-veiculos carregamento-veiculos2"
                      multiple
                      size={12}
                      value={notificacoesSelecionadas}
                      onChange={handlePredefinidas}
                    >

                      {veiculosUnicos
                        .filter(
                          v => notificacoesSelecionadas.includes(v.placa)
                        )
                        .map(v => (
                          <option
                            key={v.placa}
                            value={v.placa}
                          >
                            {v.placa} | {v.nome}
                          </option>
                        ))
                      }

                    </select>

                  </div>

                </div>

              </div>


              {/* =====================================================
                  CONFIGURAÇÃO PRINCIPAL
              ====================================================== */}

              <div className="div-principal-selecao">

                {/* GRUPOS */}

                <div>

                  <label className="form-label">
                    Grupos
                  </label>

                  <Select
                    classNamePrefix="Select-divprincipal"
                    options={options}
                    placeholder="Selecione o grupo"
                    isClearable
                    value={
                      options.find(
                        o => o.value === values.grupo
                      ) || null
                    }
                    onChange={(opcao) =>
                      handleChange({
                        target: {
                          name: "grupo",
                          value: opcao?.value ?? null,
                        },
                      })
                    }
                  />

                </div>


                {/* NOTIFICAR POR */}

                <div>

                  <label className="form-label">
                    Notificar por:
                  </label>

                  <Select
                    classNamePrefix="Select-divprincipal"
                    options={notificarOptions}
                    placeholder="Selecione"
                    isClearable
                    value={
                      notificarOptions.find(
                        o => o.value === values.notificar_por
                      ) || null
                    }
                    onChange={(opcao) =>
                      handleChange({
                        target: {
                          name: "notificar_por",
                          value: opcao?.value ?? null,
                        },
                      })
                    }
                  />

                </div>


                {/* STATUS */}

                <div>

                  <label className="form-label">
                    Status do alerta
                  </label>

                  <Select
                    classNamePrefix="Select-divprincipal"
                    options={statusOptions}
                    placeholder="Selecione"
                    isClearable
                    value={
                      statusOptions.find(
                        o => o.value === values.status_alerta
                      ) || null
                    }
                    onChange={(opcao) =>
                      handleChange({
                        target: {
                          name: "status_alerta",
                          value: opcao?.value ?? null,
                        },
                      })
                    }
                  />

                </div>

              </div>


              {/* =====================================================
                  NOTIFICAÇÕES
              ====================================================== */}

              <div className="row g-3 notificacao-div-container">

                <h5>
                  Notificação
                </h5>


                {/* =================================================
                    NOTIFICAÇÃO PRINCIPAL
                ================================================== */}

                <div className="col-6 notifi-bg-1 flex-column div-notificacao">

                  <div className="pb-2">

                    <label className="form-label">
                      Notificação principal
                    </label>

                    <Select
                      classNamePrefix="Select-divprincipal2"
                      placeholder="Selecione"
                      isClearable
                      options={tipoNotificacao1_Options}
                      value={
                        tipoNotificacaoP
                          ? tipoNotificacao1_Options.find(
                            o => o.value === tipoNotificacaoP
                          )
                          : null
                      }
                      onChange={(opcao) =>
                        setTipoNotificacaoP(
                          opcao ? opcao.value : ""
                        )
                      }
                    />


                    {/* EMERGÊNCIA */}

                    {tipoNotificacaoP === "emergencia1" && (

                      <div className="pb-2">

                        <label className="form-label">
                          Notificação de Emergência
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={criteriosPorTipo.emergencia1}
                          placeholder="Selecione"
                          isClearable
                          value={
                            criteriosPorTipo.emergencia1.find(
                              o =>
                                o.value ===
                                values?.emergencia1_criterio
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name: "emergencia1_criterio",
                                value: opcao
                                  ? opcao.value
                                  : "",
                              },
                            })
                          }
                        />

                      </div>

                    )}


                    {/* EXCESSO DE TEMPO PARADO */}

                    {tipoNotificacaoP === "excesso_tempo_parado1" && (

                      <div className="pb-2">

                        <label className="form-label">
                          Tipo de referência
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={tipoReferenciaOptions}
                          placeholder="Selecione"
                          isClearable
                          value={
                            tipoReferenciaOptions.find(
                              o => o.value === tipoReferenciaP
                            ) || null
                          }
                          onChange={(opcao) =>
                            setTipoReferenciaP(
                              opcao ? opcao.value : ""
                            )
                          }
                        />


                        {/* ÁREA */}

                        {tipoReferenciaP === "area" && (

                          <div className="pb-2 area">

                            <label className="form-label">
                              Ponto de referência
                            </label>

                            <Select
                              classNamePrefix="Select-divprincipal2"
                              options={areaOptions}
                              placeholder="Selecionar ponto de referência"
                              isClearable
                              value={
                                areaOptions.find(
                                  o =>
                                    o.value ===
                                    values.ponto_referencia_id_area_1
                                ) || null
                              }
                              onChange={(opcao) =>
                                handleChange({
                                  target: {
                                    name:
                                      "ponto_referencia_id_area_1",
                                    value:
                                      opcao?.value ?? null,
                                  },
                                })
                              }
                            />

                          </div>

                        )}


                        {/* ROTA */}

                        {tipoReferenciaP === "rota" && (

                          <div className="pb-2">

                            <label className="form-label">
                              Ponto de referência
                            </label>

                            <Select
                              classNamePrefix="Select-divprincipal2"
                              options={rotaOptions}
                              placeholder="Selecionar ponto de referência"
                              isClearable
                              value={
                                rotaOptions.find(
                                  o =>
                                    o.value ===
                                    values.ponto_referencia_id_rota_1
                                ) || null
                              }
                              onChange={(opcao) =>
                                handleChange({
                                  target: {
                                    name:
                                      "ponto_referencia_id_rota_1",
                                    value:
                                      opcao?.value ?? null,
                                  },
                                })
                              }
                            />

                          </div>

                        )}


                        {/* TEMPO MÁXIMO */}

                        {tipoReferenciaP && (

                          <div className="pb-2">

                            <label className="form-label">
                              Tempo máximo permitido
                            </label>

                            <TimePicker
                              className="timer-p"
                              format="HH:mm"
                              minuteStep={5}
                              placeholder="HH:mm"
                              value={
                                values.tempo_maximo_permitido_1
                                  ? dayjs(
                                    values.tempo_maximo_permitido_1,
                                    "HH:mm"
                                  )
                                  : null
                              }
                              onChange={(time) =>
                                handleChange({
                                  target: {
                                    name:
                                      "tempo_maximo_permitido_1",
                                    value: time
                                      ? time.format("HH:mm")
                                      : null,
                                  },
                                })
                              }
                            />

                            <small className="text-muted d-block mt-1 tempo-max">
                              Exemplo: 00:30 (30 minutos)
                            </small>

                          </div>

                        )}

                      </div>

                    )}

                  </div>


                  {/* =================================================
                      SELECT / INPUT DA NOTIFICAÇÃO PRINCIPAL
                  ================================================== */}

                  {incluiSelect1(tipoNotificacaoP) ? (

                    tipoNotificacaoP === "area1" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Ponto de referência
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={areaOptions}
                          placeholder="Selecionar ponto de referência"
                          isClearable
                          value={
                            areaOptions.find(
                              o =>
                                o.value ===
                                values.ponto_referencia_id_area_1
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name:
                                  "ponto_referencia_id_area_1",
                                value:
                                  opcao?.value ?? null,
                              },
                            })
                          }
                        />

                      </div>

                    ) : tipoNotificacaoP === "rota1" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Rotas
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={rotaOptions}
                          placeholder="Selecionar ponto de referência"
                          isClearable
                          value={
                            rotaOptions.find(
                              o =>
                                o.value ===
                                values.ponto_referencia_id_rota_1
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name:
                                  "ponto_referencia_id_rota_1",
                                value:
                                  opcao?.value ?? null,
                              },
                            })
                          }
                        />

                      </div>

                    ) : (

                      <div className="pb-2">

                        <label className="form-label">
                          Entrada
                        </label>

                        <Select
                          placeholder="Selecione uma Entrada"
                          classNamePrefix="Select-divprincipal2"
                          options={opcoesEntrada}
                          isClearable
                          value={
                            opcoesEntrada.find(
                              o =>
                                o.value ===
                                values?.criterio_valor_entrada_1
                            ) || null
                          }
                          onChange={(option) =>
                            handleChange({
                              target: {
                                name:
                                  "criterio_valor_entrada_1",
                                value: option
                                  ? option.value
                                  : "",
                              },
                            })
                          }
                        />

                      </div>

                    )

                  ) : incluiInput1(tipoNotificacaoP) ? (

                    tipoNotificacaoP === "rpm1" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Valor do RPM
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range"
                            min={0}
                            max={8000}
                            step={100}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoP}`,
                                  value: e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            className="form-control text-center"
                            style={{ width: "90px" }}
                            min={0}
                            max={8000}
                            step={100}
                            name={
                              `criterio_valor_${tipoNotificacaoP}`
                            }
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? "0"
                            }
                            onChange={(e) => {

                              const value =
                                e.target.value;

                              if (value === "") {
                                handleChange(e);
                                return;
                              }

                              const numero =
                                Number(value);

                              if (
                                numero < 0 ||
                                numero > 8000
                              ) {
                                return;
                              }

                              handleChange(e);

                            }}
                          />

                          <span className="fw-semibold">
                            RPM
                          </span>

                        </div>

                        <small className="text-muted">

                          {values[
                            `criterio_valor_${tipoNotificacaoP}`
                          ] >= 4000
                            ? "⚠️ RPM alto"
                            : "RPM normal"}

                        </small>

                      </div>

                    ) : tipoNotificacaoP === "bateria1" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Nível da bateria (%)
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range flex-grow-1"
                            min={0}
                            max={100}
                            step={1}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoP}`,
                                  value: e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            placeholder="Nível de bateria"
                            className="form-control"
                            style={{ width: "100px" }}
                            min={0}
                            max={100}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? "0"
                            }
                            onChange={(e) => {

                              const value =
                                e.target.value;

                              if (value === "") {
                                handleChange(e);
                                return;
                              }

                              const numero =
                                Number(value);

                              if (
                                numero < 0 ||
                                numero > 100
                              ) {
                                return;
                              }

                              handleChange(e);

                            }}
                            name={
                              `criterio_valor_${tipoNotificacaoP}`
                            }
                          />

                          <span>
                            %
                          </span>

                        </div>

                      </div>

                    ) : tipoNotificacaoP === "velocidade1" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Velocidade máxima
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range"
                            min={0}
                            max={200}
                            step={5}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoP}`,
                                  value: e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            className="form-control text-center"
                            style={{ width: "90px" }}
                            name={
                              `criterio_valor_${tipoNotificacaoP}`
                            }
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoP}`
                              ] ?? "0"
                            }
                            onChange={(e) =>
                              handleChange(e)
                            }
                            onBlur={(e) => {

                              const v =
                                Number(e.target.value);

                              if (isNaN(v)) {
                                return;
                              }

                              let corrigido = v;

                              if (v < 0) {
                                corrigido = 0;
                              }

                              if (v > 200) {
                                corrigido = 200;
                              }

                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoP}`,
                                  value: corrigido,
                                },
                              });

                            }}
                          />

                          <span className="fw-semibold">
                            km/h
                          </span>

                        </div>

                        <small className="text-muted">

                          {values[
                            `criterio_valor_${tipoNotificacaoP}`
                          ] >= 120
                            ? "⚠️ Velocidade muito alta"
                            : "Velocidade dentro do esperado"}

                        </small>

                      </div>

                    ) : (

                      temperaturaConfig[tipoNotificacaoP] && (

                        <div className="pb-2">

                          <label className="form-label">
                            {
                              temperaturaConfig[
                                tipoNotificacaoP
                              ].label
                            }
                          </label>

                          <div className="d-flex align-items-center gap-2">

                            <input
                              type="range"
                              className="form-range"
                              min={
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].min
                              }
                              max={
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].max
                              }
                              step={1}
                              value={
                                values[
                                `criterio_valor_${tipoNotificacaoP}`
                                ] ??
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].default
                              }
                              onChange={(e) =>
                                handleChange({
                                  target: {
                                    name:
                                      `criterio_valor_${tipoNotificacaoP}`,
                                    value:
                                      e.target.value,
                                  },
                                })
                              }
                            />

                            <input
                              type="number"
                              className="form-control text-center"
                              style={{ width: "90px" }}
                              min={
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].min
                              }
                              max={
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].max
                              }
                              step={1}
                              name={
                                `criterio_valor_${tipoNotificacaoP}`
                              }
                              value={
                                values[
                                `criterio_valor_${tipoNotificacaoP}`
                                ] ?? "0"
                              }
                              onChange={(e) =>
                                handleChange(e)
                              }
                              onBlur={(e) => {

                                const value =
                                  e.target.value;

                                if (value === "") {
                                  return;
                                }

                                const numero =
                                  Number(value);

                                const {
                                  min,
                                  max,
                                } =
                                  temperaturaConfig[
                                  tipoNotificacaoP
                                  ];

                                let corrigido =
                                  numero;

                                if (numero < min) {
                                  corrigido = min;
                                }

                                if (numero > max) {
                                  corrigido = max;
                                }

                                handleChange({
                                  target: {
                                    name:
                                      `criterio_valor_${tipoNotificacaoP}`,
                                    value: corrigido,
                                  },
                                });

                              }}
                            />

                            <span className="fw-semibold">
                              {
                                temperaturaConfig[
                                  tipoNotificacaoP
                                ].unidade
                              }
                            </span>

                          </div>

                          <small className="text-muted">

                            Faixa válida:{" "}
                            {
                              temperaturaConfig[
                                tipoNotificacaoP
                              ].min
                            }
                            {
                              temperaturaConfig[
                                tipoNotificacaoP
                              ].unidade
                            }{" "}
                            até{" "}
                            {
                              temperaturaConfig[
                                tipoNotificacaoP
                              ].max
                            }
                            {
                              temperaturaConfig[
                                tipoNotificacaoP
                              ].unidade
                            }

                          </small>

                        </div>

                      )

                    )

                  ) : null}


                  {/* CRITÉRIO PRINCIPAL */}

                  {incluiCriterio1(tipoNotificacaoP) && (

                    <div className="pb-2">

                      <label className="form-label">
                        Critério
                      </label>

                      <Select
                        className="select-grupo"
                        classNamePrefix="Select-divprincipal2"
                        placeholder="Selecione o critério"
                        options={
                          criteriosPorTipo[
                          tipoNotificacaoP
                          ] || []
                        }
                        value={
                          criteriosPorTipo[
                            tipoNotificacaoP
                          ]?.find(
                            o =>
                              o.value ===
                              values?.[
                              `${tipoNotificacaoP}_criterio`
                              ]
                          ) || null
                        }
                        onChange={(option) =>
                          handleChange({
                            target: {
                              name:
                                `${tipoNotificacaoP}_criterio`,
                              value: option
                                ? option.value
                                : "",
                            },
                          })
                        }
                        isClearable
                      />

                    </div>

                  )}

                </div>


                {/* =================================================
                    NOTIFICAÇÃO ADICIONAL
                ================================================== */}

                <div className="col-6 notifi-bg-1 flex-column div-notificacao">

                  <div className="pb-2">

                    <label className="form-label">
                      Notificação adicional (opcional)
                    </label>

                    <Select
                      classNamePrefix="Select-divprincipal2"
                      placeholder="Selecione"
                      isClearable
                      options={tipoNotificacaoS_Options}
                      value={
                        tipoNotificacaoS
                          ? tipoNotificacaoS_Options.find(
                            o =>
                              o.value ===
                              tipoNotificacaoS
                          )
                          : null
                      }
                      onChange={(opcao) =>
                        setTipoNotificacaoS(
                          opcao ? opcao.value : ""
                        )
                      }
                    />


                    {/* EMERGÊNCIA */}

                    {tipoNotificacaoS === "emergencia" && (

                      <div className="pb-2 emergencia2">

                        <label className="form-label">
                          Notificação de Emergência
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          placeholder="Selecione"
                          options={
                            criteriosPorTipoS.emergencia
                          }
                          isClearable
                          value={
                            criteriosPorTipoS.emergencia.find(
                              o =>
                                o.value ===
                                values?.emergencia_criterio
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name:
                                  "emergencia_criterio",
                                value: opcao
                                  ? opcao.value
                                  : "",
                              },
                            })
                          }
                        />

                      </div>

                    )}


                    {/* EXCESSO DE TEMPO PARADO */}

                    {tipoNotificacaoS ===
                      "excesso_tempo_parado" && (

                        <div className="pb-2">

                          <label className="form-label">
                            Tipo de referência
                          </label>

                          <Select
                            classNamePrefix="Select-divprincipal2"
                            options={
                              tipoReferenciaOptions
                            }
                            isClearable
                            value={
                              tipoReferenciaOptions.find(
                                o =>
                                  o.value ===
                                  tipoReferenciaS
                              ) || null
                            }
                            onChange={(opcao) => {

                              const tipo =
                                opcao
                                  ? opcao.value
                                  : "";

                              setTipoReferenciaS(tipo);

                            }}
                          />


                          {/* ÁREA */}

                          <div className="pb-2">

                            <label className="form-label">
                              Ponto de referência
                            </label>

                            {tipoReferenciaS === "area" && (

                              <Select
                                classNamePrefix="Select-divprincipal2"
                                options={areaOptions}
                                placeholder="Selecionar ponto de referência"
                                isClearable
                                onChange={(opcao) =>
                                  handleChange({
                                    target: {
                                      name:
                                        "ponto_referencia_id_area",
                                      value:
                                        opcao?.value ??
                                        null,
                                    },
                                  })
                                }
                              />

                            )}

                          </div>


                          {/* ROTA */}

                          {tipoReferenciaS === "rota" && (

                            <Select
                              classNamePrefix="Select-divprincipal2"
                              options={rotaOptions}
                              placeholder="Selecionar ponto de referência"
                              isClearable
                              onChange={(opcao) =>
                                handleChange({
                                  target: {
                                    name:
                                      "ponto_referencia_id_rota",
                                    value:
                                      opcao?.value ?? null,
                                  },
                                })
                              }
                            />

                          )}


                          {/* TEMPO MÁXIMO */}

                          {tipoNotificacaoS && (

                            <>

                              <label className="form-label mt-2">
                                Tempo máximo permitido
                              </label>

                              <TimePicker
                                className="timer-p"
                                format="HH:mm"
                                placeholder="HH:mm"
                                minuteStep={5}
                                value={
                                  values.tempo_maximo_permitido
                                    ? dayjs(
                                      values.tempo_maximo_permitido,
                                      "HH:mm"
                                    )
                                    : null
                                }
                                onChange={(time) =>
                                  handleChange({
                                    target: {
                                      name:
                                        "tempo_maximo_permitido",
                                      value: time
                                        ? time.format(
                                          "HH:mm"
                                        )
                                        : null,
                                    },
                                  })
                                }
                              />

                            </>

                          )}

                          <small className="text-muted d-block mt-1 tempo-max">
                            Exemplo: 00:30 (30 minutos)
                          </small>

                        </div>

                      )}

                  </div>


                  {/* SELECT / INPUT ADICIONAL */}

                  {incluiSelect(tipoNotificacaoS) ? (

                    tipoNotificacaoS === "rota" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Rotas
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={rotaOptions}
                          isClearable
                          value={
                            rotaOptions.find(
                              o =>
                                o.value ===
                                values.ponto_referencia_id_rota
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name:
                                  "ponto_referencia_id_rota",
                                value:
                                  opcao?.value ?? null,
                              },
                            })
                          }
                        />

                      </div>

                    ) : tipoNotificacaoS === "area" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Ponto de referência
                        </label>

                        <Select
                          classNamePrefix="Select-divprincipal2"
                          options={areaOptions}
                          placeholder="Selecionar ponto de referência"
                          isClearable
                          value={
                            areaOptions.find(
                              opt =>
                                opt.value ===
                                values.ponto_referencia_id_area
                            ) || null
                          }
                          onChange={(opcao) =>
                            setSelectValue(
                              "ponto_referencia_id_area",
                              opcao
                                ? opcao.value
                                : null
                            )
                          }
                        />

                      </div>

                    ) : (

                      <div className="pb-2">

                        <label className="form-label">
                          Entrada
                        </label>

                        <Select
                          className="select-grupo"
                          classNamePrefix="Select-divprincipal2"
                          placeholder="Selecionar entrada"
                          isClearable
                          options={opcoesEntrada}
                          value={
                            opcoesEntrada.find(
                              o =>
                                o.value ===
                                values?.criterio_valor_entrada
                            ) || null
                          }
                          onChange={(opcao) =>
                            handleChange({
                              target: {
                                name:
                                  "criterio_valor_entrada",
                                value: opcao
                                  ? opcao.value
                                  : "",
                              },
                            })
                          }
                        />

                      </div>

                    )

                  ) : incluiInput(tipoNotificacaoS) ? (

                    tipoNotificacaoS === "rpm" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Valor do RPM
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range"
                            min={0}
                            max={8000}
                            step={100}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoS}`,
                                  value:
                                    e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            className="form-control text-center"
                            style={{ width: "90px" }}
                            min={0}
                            max={8000}
                            step={100}
                            name={
                              `criterio_valor_${tipoNotificacaoS}`
                            }
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? "0"
                            }
                            onChange={(e) => {

                              const value =
                                e.target.value;

                              if (value === "") {
                                handleChange(e);
                                return;
                              }

                              const numero =
                                Number(value);

                              if (
                                numero < 0 ||
                                numero > 8000
                              ) {
                                return;
                              }

                              handleChange(e);

                            }}
                          />

                          <span className="fw-semibold">
                            RPM
                          </span>

                        </div>

                        <small className="text-muted">

                          {values[
                            `criterio_valor_${tipoNotificacaoS}`
                          ] >= 4000
                            ? "⚠️ RPM alto"
                            : "RPM normal"}

                        </small>

                      </div>

                    ) : tipoNotificacaoS === "bateria" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Nível da bateria (%)
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range flex-grow-1"
                            min={0}
                            max={100}
                            step={1}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoS}`,
                                  value:
                                    e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            className="form-control"
                            style={{ width: "100px" }}
                            min={0}
                            max={100}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? "0"
                            }
                            onChange={(e) => {

                              const value =
                                e.target.value;

                              if (value === "") {
                                handleChange(e);
                                return;
                              }

                              const numero =
                                Number(value);

                              if (
                                numero < 0 ||
                                numero > 100
                              ) {
                                return;
                              }

                              handleChange(e);

                            }}
                            name={
                              `criterio_valor_${tipoNotificacaoS}`
                            }
                          />

                          <span>
                            %
                          </span>

                        </div>

                      </div>

                    ) : tipoNotificacaoS === "velocidade" ? (

                      <div className="pb-2">

                        <label className="form-label">
                          Velocidade máxima
                        </label>

                        <div className="d-flex align-items-center gap-2">

                          <input
                            type="range"
                            className="form-range"
                            min={0}
                            max={200}
                            step={5}
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleChange({
                                target: {
                                  name:
                                    `criterio_valor_${tipoNotificacaoS}`,
                                  value:
                                    e.target.value,
                                },
                              })
                            }
                          />

                          <input
                            type="number"
                            className="form-control text-center"
                            style={{ width: "90px" }}
                            name={
                              `criterio_valor_${tipoNotificacaoS}`
                            }
                            value={
                              values[
                              `criterio_valor_${tipoNotificacaoS}`
                              ] ?? "0"
                            }
                            onChange={(e) =>
                              handleChange(e)
                            }
                          />

                          <span className="fw-semibold">
                            km/h
                          </span>

                        </div>

                      </div>

                    ) : (

                      <div>

                        <label className="form-label">
                          Temperatura
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Entre com o valor da temperatura"
                          name={
                            `criterio_valor_${tipoNotificacaoS}`
                          }
                          value={
                            values[
                            `criterio_valor_${tipoNotificacaoS}`
                            ] ?? ""
                          }
                          onChange={(e) =>
                            handleChange(e)
                          }
                        />

                      </div>

                    )

                  ) : null}


                  {/* CRITÉRIO ADICIONAL */}

                  {incluiCriterio(tipoNotificacaoS) && (

                    <div className="pb-2 criterio-div-notificacaoS">

                      <label className="form-label">
                        Critério
                      </label>

                      <Select
                        className="selectInfo-Notificacao"
                        classNamePrefix="Select-divprincipal2"
                        placeholder="Selecione o critério"
                        isClearable
                        options={
                          criteriosPorTipoS[
                          tipoNotificacaoS
                          ] || []
                        }
                        value={
                          criteriosPorTipoS[
                            tipoNotificacaoS
                          ]?.find(
                            o =>
                              o.value ===
                              values?.[
                              `${tipoNotificacaoS}_criterio`
                              ]
                          ) || null
                        }
                        onChange={(opcao) =>
                          handleChange({
                            target: {
                              name:
                                `${tipoNotificacaoS}_criterio`,
                              value: opcao
                                ? opcao.value
                                : "",
                            },
                          })
                        }
                      />

                    </div>

                  )}


                  {/* =================================================
                      BOTÕES
                  ================================================== */}

                  <div className="container">

                    <div className="d-flex justify-content-end">

                      <button
                        type="button"
                        className="btn btn-danger mr-2"
                        onClick={() => navigate(-1)}
                      >
                        Cancelar
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                      >
                        {modo === "edit"
                          ? "Salvar Alterações"
                          : "Cadastrar"}
                      </button>

                    </div>

                  </div>

                </div>


                {/* =================================================
                    MENSAGEM
                ================================================== */}

                <AnimatePresence>

                  {habilitarNotificacao && (

                    <motion.div
                      initial={{
                        opacity: 0,
                        y: -8
                      }}
                      animate={{
                        opacity: 1,
                        y: 0
                      }}
                      exit={{
                        opacity: 0,
                        y: -8
                      }}
                      transition={{
                        duration: 0.3,
                        ease: "easeOut"
                      }}
                    >

                      <label className="form-label">
                        Mensagem de notificação
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        maxLength={80}
                        placeholder="Não preencher envia mensagem padrão"
                        name="mensagem"
                        value={values.mensagem || ""}
                        onChange={(e) =>
                          handleChange(e)
                        }
                      />

                      <small className="text-muted">
                        Caracteres restantes{" "}
                        {80 -
                          (values.mensagem?.length || 0)}
                      </small>

                    </motion.div>

                  )}

                </AnimatePresence>


                {/* HABILITAR APP */}

                <div className="pb-2">

                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="habilitarNotificacao"
                    checked={habilitarNotificacao}
                    onChange={(e) =>
                      setHabilitarNotificacao(
                        e.target.checked
                      )
                    }
                  />

                  <label className="form-label">
                    Habilitar notificação no App
                  </label>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}
export default NotificaçãoCad;
